import type { BoxDetailsEntity } from "@/modules/box/entities/boxEntity"
import { BoxStaffRole } from "@modules/boxStaff/gateway/boxStaffDto"

export type BoxDashboardModel = {
  showDailySchedule: boolean
  showWeeklyTrialsDropIns: boolean
  showTeamTasks: boolean
  showInactiveMembers: boolean
  showKPI: boolean
}

const STAFF_ROLES = [BoxStaffRole.OWNER, BoxStaffRole.CO_OWNER, BoxStaffRole.HEAD_COACH, BoxStaffRole.COACH]
const KPI_ROLES = [BoxStaffRole.OWNER, BoxStaffRole.CO_OWNER, BoxStaffRole.FINANCIAL, BoxStaffRole.READ_ONLY]

export function createBoxDashboardModel(boxDetails: BoxDetailsEntity | null): BoxDashboardModel {
  const isStaff = boxDetails?.currentUserRole && STAFF_ROLES.includes(boxDetails.currentUserRole)
  const canSeeKPI = boxDetails?.currentUserRole && KPI_ROLES.includes(boxDetails.currentUserRole)

  return {
    showDailySchedule: true,
    showWeeklyTrialsDropIns: true,
    showTeamTasks: isStaff ?? false,
    showInactiveMembers: isStaff ?? false,
    showKPI: canSeeKPI ?? false,
  }
}
